import { Routes } from '@angular/router';
import { AppLayout } from '@/layout/components/app.layout';
import { AuthLayout } from '@/layout/components/app.authlayout';
import { Notfound } from '@/pages/notfound/notfound';
import { AuthGuard } from './app/guards/auth.guard';

export const appRoutes: Routes = [
  {
    path: '',
    component: AppLayout,
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        data: { breadcrumb: 'News Happy' },
        loadComponent: () => import('@/pages/blog/list').then((c) => c.List),
      },
      { path: 'documentation', data: { breadcrumb: 'Documentacion' },
        loadComponent: () => import('@/pages/documentation/documentation').then((c) => c.Documentation) },
      { path: 'pages', loadChildren: () => import('@/pages/pages.routes'), data: { breadcrumb: '' } },
      { path: 'billing-basis', data: { breadcrumb: 'Billing Basis' },
        loadComponent: () => import('@/pages/billing-basis/billing-basis.component').then((c) => c.BillingBasisComponent) },
      { path: 'trailer-types', data: { breadcrumb: 'Trailer Types' },
        loadComponent: () => import('@/pages/trailer-types/trailer-types.component').then(m => m.TrailerTypesComponent) },
      { path: 'transport-modalities', data: { breadcrumb: 'Transport Modalities' },
        loadComponent: () => import('@/pages/transport-modalities/transport-modalities.component').then(m => m.TransportModalitiesComponent) },
      { path: 'cargo-categories', data: { breadcrumb: 'Cargo Categories' },
        loadComponent: () => import('@/pages/cargo-categories/cargo-categories.component').then(m => m.CargoCategoriesComponent) },
      { path: 'freight-types', data: { breadcrumb: 'Freight Types' },
        loadComponent: () => import('@/pages/freight-types/freight-types.component').then(c => c.FreightTypesComponent) },
      { path: 'days-by-range', data: { breadcrumb: 'Days by Range' },
        loadComponent: () => import('@/pages/days-by-range/days-by-range.component').then(c => c.DaysByRangeComponent) },
      { path: 'fuel-prices', data: { breadcrumb: 'Fuel Prices' },
        loadComponent: () => import('@/pages/fuel-prices/fuel-prices.component').then(c => c.FuelPricesComponent) },
      { path: 'costs-per-mile-salary', data: { breadcrumb: 'Cost Per Mile (Salary)' },
        loadComponent: () => import('@/pages/costs-per-mile-salary/costs-per-mile-salary.component').then(c => c.CostsPerMileSalaryComponent) },
      { path: 'classification-by-trailer', data: { breadcrumb: 'Classification by Trailer' },
        loadComponent: () => import('@/pages/classification-by-trailer/classification-by-trailer.component').then(c => c.ClassificationByTrailerComponent) },
      { path: 'prospect-customers', data: { breadcrumb: 'Prospective Clients' },
        loadComponent: () => import('@/pages/presales/prospect-customers.component').then(m => m.ProspectCustomersComponent) },
      {
        path: 'prospect-customers/:clientId/quotes',
        data: { breadcrumb: 'Quotes' },
        loadComponent: () =>
          import('@/pages/presales/client-quotes-by-client.component')
            .then(m => m.ClientQuotesByClientComponent)
      },
    ]
  },

  // login en raíz (#/login con HashLocation)
  { path: 'login', loadComponent: () => import('@/pages/auth/login').then((c) => c.Login) },

  // compat: /auth y /auth/login → /login
  {
    path: 'auth',
    component: AuthLayout,
    children: [
      { path: '', pathMatch: 'full', redirectTo: '/login' },
      { path: 'login', redirectTo: '/login' },
      { path: 'error', redirectTo: '/notfound' }
    ]
  },

  { path: 'notfound', component: Notfound },
  { path: '**', redirectTo: '/notfound' }
];
